'use client'
import React, { ReactNode } from 'react'
import styles from './styles.module.scss'
import { useButtonClassName } from './useButtonClassName'
import { IHelperButton } from '../types'
import { Tooltip } from 'react-tooltip'

interface HelperButtonProps extends IHelperButton {
  tooltip?: string | ReactNode
}

const HelperButton: React.FC<HelperButtonProps> = ({
  type,
  state,
  onClick,
  tooltip,
}) => {
  const buttonHelpClassName = useButtonClassName(type, state)

  return (
    <div>
      <button
        type="button"
        className={`tooltip ${styles.helperButton} ${styles[buttonHelpClassName]}`}
        onClick={() => {
          onClick?.()
        }}
      />
      <>
        {tooltip ? (
          <Tooltip
            anchorSelect=".tooltip"
            place="bottom"
            style={{
              width: 'calc(100% + 10px)',
              zIndex: '100',
              background: 'rgb(0, 0, 0)',
              fontFamily: 'Gilroy Semibold',
            }}
          >
            <div className={styles.tooltip}>{tooltip}</div>
          </Tooltip>
        ) : null}
      </>
    </div>
  )
}

export default HelperButton
